interface IReportPeriod {
  startDate: string;
  endDate: string;
  isAllTime: boolean;
}
type TDownloader = (data: (string | number)[][], filename: string) => void;
export interface ReportStrategy {
  generate(): (string | number)[][];
  //   readonly currentReportData: (string | number)[][];
  //   readonly reportData: ISalesStatsByDayResponse["data"]["report"];
}

export class ReportExporter {
  private readonly strategy: ReportStrategy;
  private readonly period: {
    startDate: string;
    endDate: string;
    isAllTime: boolean;
  };

  constructor(strategy: ReportStrategy, period: IReportPeriod, private downloader: TDownloader) {
    this.strategy = strategy;
    this.period = period;
  }

  private buildFileName(fileName: string): string {
    if (this.period.isAllTime) return `${fileName}-all-time`;
    return `${fileName}_by_days-${this.period.startDate}-per-${this.period.endDate}`;
  }

  downloadReport(fileName: string): void {
    const report = this.strategy.generate();
    this.downloader(report, this.buildFileName(fileName));
  }
}
